(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["qonfi-to-embed-form-flow"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const params = new URLSearchParams(window.location.search);
    const qonfiSubmitted = params.get("qonfi-submitted");
    const randomNumber = Math.floor(Math.random() * 100000);

    const resetButton = document.querySelector('[data-reset-qonfi]');

    if (!qonfiSubmitted || qonfiSubmitted !== "true") {
      window.qonfiVariables = {
        sessionId: randomNumber
      };
      sessionStorage.setItem("qonfiSessionId", randomNumber);
    }

    setTimeout(() => {
      const nextForm = document.querySelector('.qonfi-level-2');
      const qonfiForm = document.querySelector('[data-qonfi-uuid]');

      if (qonfiSubmitted === "true") {
        nextForm && (nextForm.style.display = 'block');
        resetButton && resetButton.removeAttribute('aria-hidden');
      } else {
        qonfiForm && (qonfiForm.style.display = 'block');
        resetButton && resetButton.setAttribute('aria-hidden', 'true');
      }
    }, 1000);

    if (resetButton) {
      resetButton.addEventListener('click', () => {
        sessionStorage.removeItem("qonfiSessionId");
        window.qonfiVariables = { sessionId: '' };
        window.location.search = '';
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
